module.exports = __webpack_public_path__ + "assets/img/8916-bb.svg";